<template>
    <div class="block-editor remove-tag">
        <div class="wrapper">
            <section>
                <a-alert
                    type="info"
                    show-icon
                    message="Tags are used to categorize your visitors. You can add tags to your visitors manually or automatically using conditions. You can also use tags to trigger actions in your chatbot."
                />
            </section>
            <section>
                <div class="title">Tags to Removing</div>
                <!--@todo translate-->

                <TagDialog v-model="clone.tags" />
            </section>
        </div>
    </div>
</template>

<script>
import log2 from "../../../../../../utils/log2";
import _ from "lodash";
import TagDialog from "../../../../../../components/TagDialog";

const log = log2("RemoveTag");
export default {
    name: "RemoveTag",
    components: { TagDialog },
    props: ["value"],
    data() {
        return {
            clone: _.cloneDeep(this.value),
        };
    },
    methods: {},
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
    },
};
</script>

<style lang="scss">
.block-editor.remove-tag {
    section {
        margin-bottom: 10px;
    }

    .wrapper {
        padding: 30px;

        .title {
            margin-bottom: 10px;
            font-weight: 600;
            font-size: 16px;
            line-height: 20px;
        }

        .text-editor-wrapper {
            border-radius: 0px;
            border: 1px solid #fff;
            background: white;

            &:hover {
                border: 1px solid #006cff !important;
            }
        }
    }
}
</style>
